// extracted by mini-css-extract-plugin
export var boldText = "_7n-4";
export var checkboxContainer = "_7n-6";
export var closeIcon = "_7n-i";
export var container = "_7n-0";
export var drawer = "_7n-8";
export var drawerContent = "_7n-9";
export var extraSmallText = "_7n-5";
export var fulfillmentGroupTable = "_7n-e";
export var largeText = "_7n-3";
export var loadingSpinnerContainer = "_7n-j";
export var mediumText = "_7n-2";
export var narrow = "_7n-f";
export var notificationLink = "_7n-l";
export var packageCheckIconContainer = "_7n-7";
export var slideoutHeaderActions = "_7n-g";
export var slideoutHeaderActionsShifted = "_7n-h";
export var slideoutHeaderContainer = "_7n-a";
export var slideoutModal = "_7n-c";
export var stickyHeaderWrapper = "_7n-b";
export var table = "_7n-k";
export var tableContainer = "_7n-d";
export var tertiaryText = "_7n-1";